import Route from '@ember/routing/route';
import RSVP from 'rsvp';
import { inject as service } from '@ember/service';
import { set } from '@ember/object';
import { trackPageViewFromTransition } from 'sh-www/utils/datalayer';
import { USER } from 'sh-www/models/user';

/** @module */
const CreatorSignupBackgroundRoute = Route.extend({
  session: service(),
  store: service(),

  /** @inheritDoc */
  model() {
    const store = this.get('store');

    const equipment = store.findAll('equipment');
    const languages = store.findAll('language');
    const countries = store.findAll('country');

    const user = store.findRecord('user', this.get('session.currentUser.id'), {
      include: 'tags,profile.equipment,profile.languages',
    });

    return RSVP.all([equipment, languages, countries, user]).then(([equipment, languages, countries, user]) => ({
      equipment,
      languages,
      countries,
      user,
      profile: user.get('profile'),
    }));
  },

  activate(transition) {
    this._super(...arguments);

    set(
      this.controllerFor('signup.step'),
      'signupStep',
      USER.SELLER_SIGNUP_STEPS.EXTENDED_PROFILE,
    );

    trackPageViewFromTransition(this, transition, '/signup/step/background/');
  },
});

export default CreatorSignupBackgroundRoute;
